import { render } from "./App.vue?vue&type=template&id=bc6e46b4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bc6e46b4&lang=css"

import exportComponent from "C:\\Users\\Norbert\\webdev\\udemy-vue3\\chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__